import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, forwardRef, useEffect, useState, } from 'react';
import { useTranslation } from '@zurich/common/hooks';
import { useContractSearch } from '@zurich/search/hooks';
import { useIsDesktop } from '@zurich/ui/hooks';
import { Autocomplete, Icon, InputAdornment, ResultCardContentStyled, ResultCardStyled, Seperator, } from '@zurich/ui/legacy/components';
import { styled } from '@zurich/ui/legacy/utils';
import { ResultCardContractContent, ResultCardContractHeader, } from '../../components/ResultCardContract';
const ResultCard = ({ inputValue, value, }) => {
    const isDesktop = useIsDesktop();
    return (_jsx(ResultCardPolicyInformationStyled, { tabIndex: 0, role: "article", "data-name": "search-result-card-contract", children: _jsxs(ResultCardContentStyled, { children: [_jsx(ResultCardContractHeaderStyled, { isSmall: !isDesktop, searchValue: inputValue, result: value, className: "noCursor" }), _jsx(ResultCardContractContent, { result: value, searchValue: inputValue, isSmall: !isDesktop })] }) }));
};
export const PickContractAutocomplete = forwardRef(function PickContractAutocomplete({ onChange, filters = { searchFilterEntries: [] }, showSelectedPolicyProps, onSelectedContractResultChange, localContractResultBuffer, setLocalContractResultBuffer, ...autocompleteProps }, ref) {
    const { t } = useTranslation();
    const [value, setValue] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const isDesktop = useIsDesktop();
    const [{ results, loading }, setSearchState] = useContractSearch();
    // TODO: show error!
    useEffect(() => {
        setSearchState({
            keyword: inputValue,
            filters,
            sortFields: {},
        });
    }, [inputValue, setSearchState, filters]);
    const options = inputValue.length >= 2 ? results : [];
    return (_jsxs("div", { children: [_jsx(Autocomplete, { placeholder: t('common:search'), ...autocompleteProps, getOptionLabel: (option) => option.values.policyNo, filterOptions: (x) => x, isOptionEqualToValue: (option, value) => option.values.policyNo === value.values.policyNo, options: options, autoComplete: true, value: value, loading: loading, onChange: (_event, newValue) => {
                    onChange(newValue?.values?.policyNo ?? null);
                    setValue(newValue ?? null);
                    if (setLocalContractResultBuffer) {
                        setLocalContractResultBuffer(newValue ?? null);
                    }
                    if (onSelectedContractResultChange) {
                        onSelectedContractResultChange(newValue);
                    }
                    if (newValue === null)
                        setInputValue('');
                }, onInputChange: (event, newInputValue) => {
                    setInputValue(newInputValue);
                }, ref: ref, startAdornment: _jsx(InputAdornment, { position: "start", children: _jsx(Icon, { variant: "search" }) }), 
                // needed for showing options only under the field
                disablePortal: true, renderOption: (props, option) => (_jsxs(Fragment, { children: [_jsx("li", { ...props, children: _jsxs(ResultCardContentStyled, { children: [_jsx(ResultCardContractHeader, { isSmall: !isDesktop, searchValue: inputValue, result: option }), _jsx(ResultCardContractContent, { result: option, searchValue: inputValue, isSmall: !isDesktop })] }) }), _jsx(Seperator, { margin: (theme) => theme.spacing(1, 2, 1, 2) })] }, JSON.stringify(props))) }), showSelectedPolicyProps && localContractResultBuffer && !value && (_jsx(ResultCard, { inputValue: inputValue, value: localContractResultBuffer })), showSelectedPolicyProps && value && (_jsx(ResultCard, { inputValue: inputValue, value: value }))] }));
});
const ResultCardPolicyInformationStyled = styled(ResultCardStyled)(({ theme }) => ({
    borderColor: theme.palette.primary.main,
    '&:hover': {
        backgroundColor: theme.palette.common.white,
    },
}));
const ResultCardContractHeaderStyled = styled(({ className, ...props }) => (_jsx(ResultCardContractHeader, { ...props, className: className })))(() => ({
    '&.noCursor .MuiTypography-root': {
        cursor: 'auto',
    },
}));
